import { defaultTheme } from "waapi/waap-ui/components/Theme/Theme.constants.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";

export const lightTheme: ITheme = defaultTheme;
